import { useContext } from "react";
import { MerchantPaymentMethodContext } from "./MerchantPaymentMethodProvider";

export default function useMerchantPaymentMethodContext() {
  return useContext(MerchantPaymentMethodContext);
};
